import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [optionalCookies, setOptionalCookies] = useState(true);

  useEffect(() => {
    const consent = Cookies.get('cookie_consent');
    const manuallyOpened = sessionStorage.getItem('manual_cookie_open');
    
    // If user hasn't accepted yet OR clicked "Manage Cookies"
    if (!consent || manuallyOpened === 'true') {
      setIsVisible(true);
      sessionStorage.removeItem('manual_cookie_open');
    }
  }, []);

  const acceptAll = () => {
    Cookies.set('cookie_consent', 'accepted', { expires: 365 });
    Cookies.set('optional_cookies', 'true', { expires: 365 });
    setIsVisible(false);
  };

  const rejectAll = () => {
    Cookies.set('cookie_consent', 'rejected', { expires: 365 });
    Cookies.set('optional_cookies', 'false', { expires: 365 });
    setIsVisible(false);
  };

  const savePreferences = () => {
    Cookies.set('cookie_consent', 'custom', { expires: 365 });
    Cookies.set('optional_cookies', optionalCookies.toString(), { expires: 365 });
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 w-[95%] md:w-[80%] bg-white border border-gray-300 rounded-xl shadow-2xl px-6 py-5 z-50 text-sm flex flex-col space-y-4 font-sans transition-all duration-300">
      {!showPreferences ? (
        <>
          <p className="text-black">
            🍪 We use cookies to improve your experience. You can accept, reject, or customize your preferences.
          </p>
          <div className="flex flex-col md:flex-row justify-end gap-2">
            <button
              onClick={acceptAll}
              className="px-4 py-2 bg-green-700 text-white rounded-md hover:bg-green-700 transition"
              aria-label='Accept All'
            >
              Accept All
            </button>
            <button
              onClick={() => setShowPreferences(true)}
              className="px-4 py-2 bg-yellow-400 text-black rounded-md hover:bg-yellow-600 transition"
              aria-label='Change My Preferences'
            >
              Change My Preferences
            </button>
            <button
              onClick={rejectAll}
              className="px-4 py-2 bg-gray-300 text-black rounded-md hover:bg-gray-200 transition"
              aria-label='Reject All'
            >
              Reject All
            </button>
          </div>
        </>
      ) : (
        <>
          <p className="text-gray-800">
            ⚙️ Customize your cookie settings. Required cookies are always active.
          </p>
          <div className="flex items-center justify-between border rounded-lg px-4 py-3 bg-gray-50">
            <label htmlFor="optionalCookies" className="text-gray-700">
              Optional Cookies (e.g., Analytics)
            </label>
            <input
              id="optionalCookies"
              type="checkbox"
              checked={optionalCookies}
              onChange={() => setOptionalCookies(!optionalCookies)}
              className="h-4 w-4 text-blue-600"
            />
          </div>
          <div className="flex justify-end gap-2">
            <button
              onClick={() => setShowPreferences(false)}
              className="px-4 py-2 bg-gray-100 text-gray-800 rounded-md hover:bg-gray-200 transition"
              aria-label='Back to cookie consent options'
            >
              Back
            </button>
            <button
              onClick={savePreferences}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
              aria-label='Save cookie preferences'  
            >
              Save Preferences
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CookieConsent;
